import type { RouteType } from "ui-kit";
import { lazy } from "ui-kit";

import { paths } from "../paths/campaigns";

export const routes: RouteType[] = [
  {
    path: paths.list,
    component: lazy(() => import("../pages/campaigns/List")),
  },
  {
    path: paths.create,
    component: lazy(() => import("../pages/campaigns/Create")),
  },
  {
    path: paths.edit,
    component: lazy(() => import("../pages/campaigns/Edit")),
  },
  {
    path: paths.view,
    component: lazy(() => import("../pages/campaigns/View")),
  },
];
